import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Asset, Box, Card, Typography } from '@altermaind/web/ui';
import { SwitchDarkOrLightMode } from '@/_shared/components';
import { Tooltip } from '@/_shared/components/Tooltip';
import { getAspectColorsCall } from '@/aspect/state';

type Props = {
  dark: boolean;
  setDark: (dark: boolean) => void;
  colorSuggested?: string;
};

export const PreviewPlatform: FC<Props> = ({ dark, setDark, colorSuggested }) => {
  const t = useTranslations('settings.tabs.aspect');
  const { response: responseGetAspectColors } = getAspectColorsCall.hook();

  return (
    <>
      <Box textAlign='center' mb='xs' alignItems='center' display='flex' justifyContent='center'>
        <Typography variant='p2/light'>{t('previewLabel')}</Typography>
        <Tooltip iconProps={{ size: 'xs', fill: 'grey/light' }} containerProps={{ ml: 'xxs' }}>
          {t('previewLabelTooltip')}
        </Tooltip>
      </Box>
      <Card backgroundColor='grey/dark/background'>
        {dark ? (
          <Box
            display='flex'
            borderRadius='s'
            backgroundColor={
              responseGetAspectColors &&
              (responseGetAspectColors?.colors?.find(color => color.id === colorSuggested)
                ?.dark as never)
            }
          >
            <Asset width='100%' domain='images' name='configExampleDark' />
          </Box>
        ) : (
          <Box
            display='flex'
            borderRadius='s'
            backgroundColor={
              responseGetAspectColors?.colors?.find(color => color.id === colorSuggested)
                ?.light as never
            }
          >
            <Asset width='100%' domain='images' name='configExampleLight' />
          </Box>
        )}
      </Card>
      <Box display='flex' justifyContent='center' mt='s'>
        <SwitchDarkOrLightMode isDarkMode={dark} onClick={() => setDark(!dark)} />
      </Box>
    </>
  );
};
